import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import PurchasedPassCard from "../passes/PurchasedPassCard";
import $ from "jquery";
import { validatePrice } from "../../commonData";
import { postMethod } from "../../requests";
import RegisterPaymentForm from "../forms/RegisterPaymentForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const RegisterPaymentModal = (props) => {
    const { t } = useTranslation();
    const { onClose, pass } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [payment, setPayment] = useState({
        paymentMethod: null,
        user_id: pass.user_id,
        payment_amount: (pass.up_price.toFixed(2) - pass.up_paid.toFixed(2)).toFixed(2).toString().replace(".", ","),
        payment_date: new Date(),
        payment_comment: "",
        order_number: pass.order_number,
    });
    const [loading, setLoading] = useState(true);
    const [privillege, setPrivillege] = useState(null);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!validatePrice(payment.payment_amount) || payment.payment_amount.length === 0 || !payment.payment_amount.replace(/\s+/, "")) {
            $("#paymentAmount").addClass("is-invalid");
            errors.push(t("error.invalidPaymentAmount"));
        }
        if (payment.payment_comment && (payment.payment_comment.length === 0 || !payment.payment_comment.replace(/\s+/, ""))) {
            $("#paymentComment").addClass("is-invalid");
            errors.push(t("error.invalidPaymentComment"));
        } else if (payment.payment_comment && payment.payment_comment.length > 255) {
            $("#paymentComment").addClass("is-invalid");
            errors.push(t("error.paymentCommentTooLong"));
        }
        if (!payment.paymentMethod) {
            $(`#paymentType`).addClass("is-invalid");
            errors.push(t("error.noCheckedPaymentMethod"));
        }
        if (!payment.payment_date) {
            $(`#paymentDate`).addClass("is-invalid");
            errors.push(t("error.noPaymentDate"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.creatingNewPayment") }]);
            setBlockForm(true);
            addNewPayment();
        }
    };

    const addNewPayment = async () => {
        const res = await postMethod("/add-new-payment-for-pass", { paymentData: payment, upID: pass.up_id });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "addnewpayment" }]);
            onClose();
        }
    };

    //check if there's payment for this pass already
    /* const checkPayment = async () => {
        const res = await postMethod("/check-payment-for-pass", { upID: pass.up_id });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "addnewpayment" }]);
            onClose();
        }
    }; */

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    const checkPurchasePassPrivillege = async () => {
        const res = await postMethod("/check-purchase-pass-privillege");
        setPrivillege(res.data.status);
    };

    useEffect(() => {
        if (privillege !== null) setLoading(false);
        // eslint-disable-next-line
    }, [privillege]);

    useEffect(() => {
        const textarea = document.getElementById("paymentComment");
        autoResize(textarea);
        textarea.addEventListener("input", function () {
            autoResize(this);
        });
        checkPurchasePassPrivillege();
        //checkPayment();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Modal show={true} onHide={onClose} backdrop={formChanged ? "static" : true}>
                <Form onSubmit={checkValidation} autoComplete="off">
                    <Modal.Header closeButton>
                        <Modal.Title>{t("payments.registerPayment")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12}>
                                {loading ? (
                                    <p className="fs-6 text-center">
                                        {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                    </p>
                                ) : (
                                    <PurchasedPassCard pass={pass} i={0} allowedPermission={privillege} smallCard />
                                )}
                            </Col>
                        </Row>
                        <RegisterPaymentForm payment={payment} setPayment={setPayment} setFormChanged={setFormChanged} blockForm={blockForm} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={onClose}>
                            {t("cancel")}
                        </Button>
                        <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                            {t("payments.addPayment")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default RegisterPaymentModal;
